import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function RepairCenterPage() {
    const { t } = useTranslation(['home', 'page']);

    useEffect(() => {
        document.title = t('pages:repairCenter');
    }, []);

    usePreventClickjacking();

    return (
        <>
            <div className="container2">
                <div className="contentPageContainer2">
                    <div className="container-grande2">
                        <h4>{t('pages:repairCenter')}</h4>
                        <p>{t('home:repairCenterPage.PageContent1')}</p>
                        <p>{t('home:repairCenterPage.PageContent2')}</p>
                        <ul className="column">
                            <li>{t('home:repairCenterPage.PageContentUL1')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL2')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL3')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL4')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL5')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL6')}</li>
                            <li>{t('home:repairCenterPage.PageContentUL7')}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RepairCenterPage;
